import axiosClient from './axiosClient'

const hitpayApi = {
  createHitpayPayment: (data) => {
    const url = '/create-hitpay-payment'
    return axiosClient.post(url, data)
  },

  refreshHitpayPayment: (data) => {
    const url = '/refresh-hitpay-payment'
    return axiosClient.post(url, data)
  },

  deleteHitpayTransaction: (data) => {
    const url = '/delete-hitpay-transaction'
    return axiosClient.post(url, data)
  },
}

export default hitpayApi
